import { Button, Modal, Row } from 'antd';
import styled from 'styled-components';

export const StyledSelectUsersModal = styled(Modal)`
  .ant-modal-body {
    background: ${props => props.theme.palette.background.primary80};
    border-radius: 10px;
    padding: 30px 50px;

    h3 {
      text-align: center;
      font-weight: normal;
      font-size: 24px;
      color: ${props => props.theme.palette.text.primary};
    }
  }
`;

export const StyledRow = styled(Row)`
  background: ${props => props.theme.palette.background.light};
  margin-bottom: 22px;
`;

export const StyledAddBtn = styled(Button)`
  padding: 4.4px 20px !important;
  min-width: 96px !important;
  height: 32px !important;
`;
